import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Wallet(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Wallet", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M31.5868 8.13804 19.3592 5.4139c-.3194-.06971-.6527-.03589-.9517.09655-.2941.13227-.5364.35766-.6896.64138-.5251 2.11407-1.2717 4.16677-2.2276 6.12417-1.8008 3.665-4.2978 6.9443-7.35175 9.6551H31.5868V8.13804Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.6543 21.2417c1.9595-2.2588 3.6175-4.7625 4.9324-7.4483.6364-1.3014 1.1892-2.642 1.6552-4.01375.0542-.16138.1662-.29701.3144-.38079.1482-.08378.3221-.10978.4883-.073l6.0131 1.34004c.3056.0681.579.2381.7751.4821.1962.244.3035.5475.3043.8606v9.2331H13.6543Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.9299 14.3446c.3809 0 .6896-.3087.6896-.6896s-.3087-.6897-.6896-.6897-.6897.3088-.6897.6897c0 .3809.3088.6896.6897.6896Zm-2.0676 8.2761c1.9045 0 3.4483-1.5439 3.4483-3.4483s-1.5438-3.4483-3.4483-3.4483c-1.9044 0-3.4482 1.5439-3.4482 3.4483s1.5438 3.4483 3.4482 3.4483Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.656 24.0002c3.4192-2.3043 6.2541-5.374 8.2794-8.9655.7565-1.3602 1.3867-2.7869 1.8827-4.2621.0985-.1784.1581-.3757.1751-.5788.017-.20307-.009-.40747-.0765-.59981-.0712-.19307-.1835-.36837-.3291-.51376-.1456-.14539-.3211-.25741-.5143-.32831L30.1471 4.08227c-.3023-.10719-.6319-.1097-.9358-.00715-.3039.10255-.5645.30423-.7401.57266-1.2422 2.8989-2.7381 5.68232-4.4703 8.31792-2.6994 4.1018-5.948 7.8145-9.6552 11.0345H33.656Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.2402 22.6207c2.3912-2.2349 4.5513-4.7048 6.4476-7.3724 1.3335-1.8767 2.5319-3.8458 3.5862-5.89244.0752-.14698.2011-.2618.3543-.32328.1533-.06147.3236-.06545.4795-.0112l6.9945 2.40072c.0955.0325.1826.0856.2553.1555.0727.0699.1292.1549.1655.249.0363.0941.0516.195.0446.2956-.0069.1007-.0358.1985-.0847.2868-.1076.1995-.2186.3988-.3331.5979-2.2327 3.8274-5.2876 7.1111-8.9441 9.6138h-8.9656Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.2725 21.3077c1.9044 0 3.4483-1.5439 3.4483-3.4483s-1.5439-3.4483-3.4483-3.4483-3.4483 1.5439-3.4483 3.4483 1.5439 3.4483 3.4483 3.4483Zm4.0715-7.6525c.3808 0 .6896-.3088.6896-.6897 0-.3809-.3088-.6896-.6896-.6896-.3809 0-.6897.3087-.6897.6896s.3088.6897.6897.6897Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.8632 19.1724H10.8977c-2.28532 0-4.13793 1.8526-4.13793 4.1379V39.862c0 2.2853 1.85261 4.1379 4.13793 4.1379h28.9655c2.2853 0 4.1379-1.8526 4.1379-4.1379V23.3103c0-2.2853-1.8526-4.1379-4.1379-4.1379Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.0345 26.0688H6.75862C5.23508 26.0688 4 27.3039 4 28.8274v5.5172c0 1.5236 1.23508 2.7587 2.75862 2.7587h8.27588c1.5235 0 2.7586-1.2351 2.7586-2.7587v-5.5172c0-1.5235-1.2351-2.7586-2.7586-2.7586Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.2758 32.9657c.7618 0 1.3793-.6176 1.3793-1.3794 0-.7617-.6175-1.3793-1.3793-1.3793-.7618 0-1.3793.6176-1.3793 1.3793 0 .7618.6175 1.3794 1.3793 1.3794Zm23.4483 7.586h-4.138c-.1829 0-.3583-.0727-.4876-.202-.1294-.1294-.202-.3048-.202-.4877s.0726-.3583.202-.4876c.1293-.1294.3047-.202.4876-.202h4.138c.1829 0 .3583.0726.4876.202.1294.1293.202.3047.202.4876 0 .1829-.0726.3583-.202.4877-.1293.1293-.3047.202-.4876.202Zm4.1379 0h-1.3793c-.1829 0-.3583-.0727-.4877-.202-.1293-.1294-.202-.3048-.202-.4877s.0727-.3583.202-.4876c.1294-.1294.3048-.202.4877-.202h1.3793c.1829 0 .3583.0726.4877.202.1293.1293.202.3047.202.4876 0 .1829-.0727.3583-.202.4877-.1294.1293-.3048.202-.4877.202Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
Wallet.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Wallet"
};
validateTidalLicense();
export {
  Wallet
};
//# sourceMappingURL=Wallet.js.map
